import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { AuthClientConfig, provideAuth0 } from '@auth0/auth0-angular';
import { provideHttpClient } from '@angular/common/http';
import { authConfigProvider } from '../lib/services/appconfig.service';
import { DomianProviderService } from '../lib/services/domain-provider.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(),
    provideAuth0(),
    {
      provide: APP_INITIALIZER,
      useFactory: authConfigProvider,
      deps: [DomianProviderService, AuthClientConfig],
      multi: true,
    },
  ],
};
